module.exports = __webpack_public_path__ + "static/media/cert_54.2e89cbc1.jpg";